import { AppElement, AppFC } from '../../../interfaces';

export const ErrorMessage: AppFC = ({
  children,
  className,
  ...rest
}): AppElement => <p className={`absolute w-full text-[12px] text-end text-error ${className}`} {...rest}>{children}</p>;
